import React, { useState } from "react";
import { fileUrl } from "@/lib/api";
import { touchIcon } from "@/lib/touchpoints";
import { ProblemDialog } from "@/components/ProblemDialog";
import { Plus, Trash2 } from "lucide-react";

function FindingRow({ f, testid, onDelete }) {
  const Icon = touchIcon(f.area, f.item);
  return (
    <div className="rounded-xl bg-[#F7F5F1] p-2.5 flex items-start gap-3" data-testid={testid}>
      <Icon className="h-6 w-6 text-[#6E7A63] shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0 space-y-1.5">
        <div className="text-sm font-medium text-[#45423C]">{f.item || "Πρόβλημα"}</div>
        {f.description && <p className="text-sm text-[#6F6A60]">{f.description}</p>}
        {f.audio && <audio controls src={fileUrl(f.audio)} className="h-8 w-full max-w-xs" />}
      </div>
      {f.photo && <a href={fileUrl(f.photo)} target="_blank" rel="noreferrer"><img src={fileUrl(f.photo)} alt="" className="h-12 w-12 rounded-lg object-cover border border-[#E3DED4]" /></a>}
      <button type="button" data-testid={`${testid}-del`} onClick={onDelete} className="text-[#991B1B] p-1"><Trash2 className="h-4 w-4" /></button>
    </div>
  );
}

export function WinterFindings({ areas, findings, onChange, upload }) {
  const [dlgArea, setDlgArea] = useState(null);
  const list = findings || [];
  return (
    <div className="space-y-4" data-testid="winter-findings">
      {areas.map((area) => {
        const rows = list.map((f, idx) => ({ f, idx })).filter(({ f }) => f.area === area);
        const slug = area.toLowerCase().replace(/\s+/g, "-");
        return (
          <div key={area} className="rounded-2xl border border-[#E3DED4] p-4 space-y-2" data-testid={`winter-area-${slug}`}>
            <div className="flex items-center justify-between">
              <h3 className="font-medium text-[#45423C]">{area}</h3>
              <span className="text-xs text-[#8A8577]">{rows.length} {rows.length === 1 ? "πρόβλημα" : "προβλήματα"}</span>
            </div>
            {rows.map(({ f, idx }, n) => (
              <FindingRow key={`${area}-${idx}`} f={f} testid={`winter-row-${slug}-${n}`} onDelete={() => onChange(list.filter((_, j) => j !== idx), true)} />
            ))}
            <button type="button" data-testid={`winter-add-${slug}`} onClick={() => setDlgArea(area)}
              className="text-sm text-[#C86235] inline-flex items-center gap-1"><Plus className="h-4 w-4" /> Πρόβλημα</button>
          </div>
        );
      })}
      {dlgArea && (
        <ProblemDialog area={dlgArea} upload={upload} onClose={() => setDlgArea(null)}
          onSave={(f) => { onChange([...list, f], true); setDlgArea(null); }} />
      )}
    </div>
  );
}
